const getWarehouseDisplayName = ({
  businessCenterLabel,
  name
}) => {
  if (!name || !businessCenterLabel) {
    return name;
  }
  const businessCenterAbbreviationToReplace = "Bus Ctr";
  const displayName = name.replace(
    new RegExp(businessCenterAbbreviationToReplace, "gi"),
    businessCenterLabel
  );
  return displayName;
};
export {
  getWarehouseDisplayName
};
